import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import apiConfig from "../utils/apiConfig";
import { IBulkPatchPartResponse, PartStatus } from "../models/Part";

interface IBulkStatusRequest {
  partIds: string[];
  data: { partStatus: PartStatus };
}

/**
 * Moves a selection of parts to another status through the existing bulk patch. The queue uses
 * it to send parts to QC; the enum goes over as its number, which is how the API binds enums.
 * This acts on the part straight away - it is not staged.
 */
export default function usePartBulkStatus(componentName = "usePartBulkStatus") {
  const { patch } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();

  const bulkSetStatus = useMutation(
    ({ partIds, partStatus }: { partIds: string[]; partStatus: PartStatus }) =>
      patch<IBulkPatchPartResponse>("/part/bulk", {
        partIds,
        data: { partStatus },
      } as IBulkStatusRequest),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["job"]);
        queryClient.invalidateQueries(["parts"]);
        queryClient.invalidateQueries(["partDetails"]);
        queryClient.invalidateQueries(["pagedTable"]);
        queryClient.invalidateQueries(["listingStats"]);
      },
    }
  );

  return {
    bulkSetStatus,
  };
}
